/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconBulletFill from '@telus-uds/palette-allium/build/rn/icons/BulletFill'
const theme = {
  appearances: {
    compact: {
      description: 'When true it will reduce the line height of the list item.',
      type: 'variant',
      values: [ true ]
    },
    size: {
      description: 'Indicates list item text size.',
      type: 'variant',
      values: [ 'large', 'small' ]
    }
  },
  rules: [
    {
      if: { size: 'large' },
      tokens: {
        iconMarginTop: 4,
        itemFontSize: 20,
        itemIconSize: 24,
        itemLineHeight: 1.6
      }
    },
    {
      if: { size: 'small' },
      tokens: {
        iconMarginTop: 0,
        itemBulletContainerHeight: 20,
        itemFontSize: 14,
        itemIconSize: 20,
        itemLineHeight: 1.42857142857
      }
    },
    {
      if: { compact: true },
      tokens: { iconMarginTop: 0, itemLineHeight: 1.25 }
    },
    {
      if: { compact: true, size: 'small' },
      tokens: { itemLineHeight: 1.14285714286 }
    },
    {
      if: { compact: true, size: 'large' },
      tokens: { itemLineHeight: 1.2 }
    }
  ],
  tokens: {
    bulletIcon: PaletteIconBulletFill,
    dividerColor: '#b2b9bf',
    dividerSize: 1,
    iconMarginTop: 0,
    interItemMargin: 8,
    interItemMarginWithDivider: 16,
    itemBulletColor: '#4b286d',
    itemBulletContainerAlign: 'center',
    itemBulletContainerHeight: 24,
    itemBulletContainerWidth: 24,
    itemFontName: 'HNforTELUSSA',
    itemFontSize: 16,
    itemFontWeight: '400',
    itemIconColor: '#4b286d',
    itemIconSize: 24,
    itemLineHeight: 1.5,
    itemTextColor: '#414547',
    listGutter: 8
  }
}
export default theme
